import _Set from "@babel/runtime-corejs2/core-js/set";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React, { useState, useEffect, useCallback, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mch-group/uikit-components';
import { Autocomplete } from '@dmi-mch/services';
import { buildSelectedWithConvertOptions, buildSelectOptions, validateAxiosResponse as ValidateAxiosResponse, logger as Logger, useDebounce } from '@dmi-mch/utils';
import CMultiSelect from './common/CMultiSelect';
/**
 * This is a Form component to search artists.
 *  - It allows Multiple and Single selection modes
 *  - It accepts default values, both in simple and multiple modes.
 *  - In Multiple everything works with arrays, in Single, no arrays.
 * */

var GallerySelector = memo(function (props) {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      userInputValue = _useState2[0],
      setUserInputValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var debouncedSearchTerm = useDebounce(userInputValue, 500);
  var searchTerm = useRef(null);
  var name = props.name,
      label = props.label,
      context = props.context,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {} : _props$setFieldValue,
      fieldName = props.fieldName,
      defaultValueSingle = props.defaultValueSingle,
      defaultValueMultiple = props.defaultValueMultiple,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$showResetButto = props.showResetButton,
      showResetButton = _props$showResetButto === void 0 ? false : _props$showResetButto,
      callback = props.callback,
      _props$bindResetContr = props.bindResetControl,
      bindResetControl = _props$bindResetContr === void 0 ? function () {} : _props$bindResetContr,
      isAccount = props.isAccount;

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      lists = _useState6[0],
      setLists = _useState6[1];

  var resetControl = function resetControl() {
    setLists(null);
  };

  bindResetControl(resetControl);
  /** FIRST POINT OF ENTRY FROM THE SEMANTIC UI COMPONENT, AFTER A CHANGE IN THE SELECTION. */
  // Multiple

  var handleChangeMultiple = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, data) {
      var latestAddition, latestAdditionJSON, isFound, newLists;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              latestAddition = data.value.slice(-1).pop();
              latestAdditionJSON = lists && lists.listForRender && lists.listForRender.find(function (item) {
                return item.value === latestAddition;
              });
              isFound = lists && lists.selectedMultipleValues.find(function (item) {
                return item.value === latestAddition;
              });
              newLists = _objectSpread({}, lists);

              if (latestAdditionJSON && !isFound) {
                newLists.selectedMultipleValues = [].concat(_toConsumableArray(lists.selectedMultipleValues), [latestAdditionJSON]);
                setLists(newLists);
                setFieldValue(fieldName, newLists.selectedMultipleValues);
              } else {
                // Remove if not in the list
                lists.selectedMultipleValues.forEach(function (gallery) {
                  if (!data.value.includes(gallery.value)) {
                    newLists.selectedMultipleValues = _toConsumableArray(lists.selectedMultipleValues.filter(function (item) {
                      return item.value !== gallery.value;
                    }));

                    if (isAccount) {
                      setFieldValue('accountsList', newLists);
                    }

                    setLists(newLists);
                    setFieldValue(fieldName, newLists.selectedMultipleValues);
                  }
                });
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [fieldName, isAccount, lists, setFieldValue]); // Single

  var handleChangeSingle = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event, data) {
      var latestAdditionJSON, newLists;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              latestAdditionJSON = lists && lists.listForRender && lists.listForRender.find(function (item) {
                return item.value === data.value;
              }) || null;
              newLists = _objectSpread({}, lists);
              newLists.selectedSingleValue = latestAdditionJSON;

              if (!latestAdditionJSON) {
                newLists.listForRender = [];
              }

              setLists(newLists);
              setFieldValue(fieldName, newLists.selectedSingleValue);

              if (typeof callback === 'function') {
                callback(data.value);
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), [fieldName, lists, setFieldValue, callback]);
  var setSearchTerm = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value) {
      var galleryAutocomplete, galleriesList, selectItem, dropdownOptions, arrWithDuplicates, newLists;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setIsLoading(true);
              _context3.prev = 1;

              if (isAccount) {
                galleryAutocomplete = new Autocomplete(context, 'accounts', 'Account', 'en');
              } else {
                galleryAutocomplete = new Autocomplete(context, 'catalog', 'Gallery', 'en');
              }

              _context3.next = 5;
              return galleryAutocomplete.search(value);

            case 5:
              galleriesList = _context3.sent;
              setIsLoading(false);

              if (ValidateAxiosResponse(galleriesList)) {
                selectItem = {
                  key: 'entityId',
                  value: 'entityId',
                  text: 'title',
                  name: 'title'
                };
                dropdownOptions = isAccount ? buildSelectOptions(galleriesList.data, selectItem) : buildSelectedWithConvertOptions(galleriesList.data, selectItem);
                arrWithDuplicates = null;
                newLists = _objectSpread({}, lists);

                if (multiple) {
                  arrWithDuplicates = lists && lists.selectedMultipleValues ? dropdownOptions.concat(lists.selectedMultipleValues) : dropdownOptions;
                  newLists.selectedMultipleValues = lists ? _toConsumableArray(lists.selectedMultipleValues) : [];
                } else {
                  // If there is something selected, concatenate, otherwise, just take the dropdown list
                  arrWithDuplicates = lists && lists.selectedSingleValue ? dropdownOptions.concat(lists.selectedSingleValue) : dropdownOptions;
                  newLists.selectedSingleValue = lists ? lists.selectedSingleValue : null;
                }

                newLists.listForRender = _toConsumableArray(new _Set(arrWithDuplicates));
                setLists(newLists);
              }

              _context3.next = 14;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](1);
              Logger(_context3.t0);
              setIsLoading(false);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 10]]);
    }));

    return function (_x5) {
      return _ref3.apply(this, arguments);
    };
  }(), [isAccount, context, lists, multiple]);

  var handleMultipleSelection = function handleMultipleSelection(selectedList) {
    if (selectedList.length > 0) {
      var selectedValues = selectedList.map(function (element) {
        return element.value;
      });
      handleChangeMultiple(null, {
        value: selectedValues
      });
    } else {
      handleChangeMultiple(null, {
        value: []
      });
    }
  };

  var handleSingleSelection = function handleSingleSelection(selectItem) {
    if (selectItem) {
      handleChangeSingle(null, {
        value: selectItem.value
      });
    } else {
      handleChangeSingle(null, {
        value: []
      });
    }
  }; // Handle single selected value


  var getSelectedOptionSingle = function getSelectedOptionSingle() {
    if (lists && lists.selectedSingleValue && lists.listForRender) {
      var foundElement = lists && lists.listForRender.find(function (element) {
        return element.value === lists.selectedSingleValue.value;
      });

      if (foundElement) {
        return [foundElement];
      }

      return [];
    }

    return [];
  }; // Debouncing the custom location input


  useEffect(function () {
    if (debouncedSearchTerm && debouncedSearchTerm !== searchTerm.current) {
      setSearchTerm(debouncedSearchTerm);
      searchTerm.current = debouncedSearchTerm;
    }
  }, [debouncedSearchTerm, setSearchTerm]); // Set the lists to be used on the dropdowns

  useEffect(function () {
    if (multiple) {
      setLists({
        selectedMultipleValues: defaultValueMultiple || [],
        listForRender: defaultValueMultiple
      });
    } else {
      setLists({
        selectedSingleValue: defaultValueSingle,
        listForRender: defaultValueSingle ? [defaultValueSingle] : []
      });
    }
  }, [defaultValueMultiple, defaultValueSingle, multiple]);

  if (multiple) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, showResetButton && /*#__PURE__*/React.createElement(Button, {
      size: "compact",
      variant: "secondary",
      onClick: resetControl,
      className: "text-capitalize fw-normal border-1"
    }, "Reset"), /*#__PURE__*/React.createElement(CMultiSelect, {
      options: lists && lists.listForRender ? lists.listForRender : [],
      name: name,
      label: label,
      placeholder: "",
      closeOnSelect: true,
      showArrow: true,
      loading: isLoading // eslint-disable-next-line no-unused-vars
      ,
      onSelect: function onSelect(selectedList, selectedItem) {
        handleMultipleSelection(selectedList);
      } // eslint-disable-next-line no-unused-vars
      ,
      onRemove: function onRemove(selectedList, removedItem) {
        handleMultipleSelection(null);
      },
      onSearch: function onSearch(searchBy) {
        setUserInputValue(searchBy);
      },
      selectedValues: lists && lists.selectedMultipleValues ? lists.selectedMultipleValues && lists.selectedMultipleValues.map(function (item) {
        return {
          key: item.key,
          value: item.value,
          text: item.text,
          name: item.value
        };
      }) : []
    }));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, showResetButton && /*#__PURE__*/React.createElement(Button, {
    size: "compact",
    variant: "secondary",
    onClick: resetControl,
    className: "text-capitalize fw-normal border-1"
  }, "Reset"), /*#__PURE__*/React.createElement(CMultiSelect, {
    options: lists && lists.listForRender,
    name: name,
    label: label,
    placeholder: "",
    closeOnSelect: true,
    showArrow: true,
    keepSearchTerm: true,
    selectionLimit: 1,
    loading: isLoading // eslint-disable-next-line no-unused-vars
    ,
    onSelect: function onSelect(selectedList, selectedItem) {
      handleSingleSelection(selectedItem);
    } // eslint-disable-next-line no-unused-vars
    ,
    onRemove: function onRemove(selectedList, removedItem) {
      handleSingleSelection(null);
    },
    onSearch: function onSearch(searchBy) {
      setUserInputValue(searchBy);
    },
    selectedValues: getSelectedOptionSingle()
  }));
});
GallerySelector.propTypes = {
  selected: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string,
  setFieldValue: PropTypes.func,
  disabled: PropTypes.bool,
  dropDownOptions: PropTypes.array,
  context: PropTypes.object,
  fieldName: PropTypes.string,
  defaultValueSingle: PropTypes.object,
  defaultValueMultiple: PropTypes.array,
  multiple: PropTypes.bool,
  showResetButton: PropTypes.bool,
  bindResetControl: PropTypes.func,
  callback: PropTypes.func,
  isAccount: PropTypes.bool
};
export default GallerySelector;